<template>
  <v-dialog v-model="dialog" persistent max-width="35%">
    <v-card class="pb-2">
      <v-toolbar color="#313a46">
        <v-card-title class="text-h5 white--text"> Produtos </v-card-title>
      </v-toolbar>
      <v-card-text>
        <BaseDataTable
          :headers="headers"
          :items="products"
          @pageChange="fetchProducts({ page: $event })"
          :paginate="true"
          :currentPage="currentPage"
          :lastPage="lastPage"
          :loading="loading"
          class="mt-4"
        >
          <template v-slot:item.descricao_produto="{ item }">
            {{ formatText(item.descricao_produto) }}
          </template>
        </BaseDataTable>
      </v-card-text>
      <v-card-actions class="mx-2">
        <v-spacer></v-spacer>
        <v-btn
          outlined
          class="white--text btn-form"
          color="error"
          @click="closeModal()"
        >
          FECHAR
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import toast from "@/commom/toast";
import BaseDataTable from "@/components/BaseDataTable.vue";
import NcmContabilizar from "@/services/http/nfeNcm/NcmContabilizar";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    idNcm: {
      type: String,
    },
  },

  components: {
    BaseDataTable,
  },

  data() {
    return {
      currentPage: 1,
      lastPage: 1,
      products: [],
      loading: true,
      headers: [
        {
          text: "Descrição",
          value: "descricao_produto",
          sortable: false,
          filterable: false,
        },
      ],
    };
  },

  watch: {
    idNcm(value) {
      this.fetchProducts();
    },
  },

  methods: {
    async fetchProducts(filters = {}) {
      this.loading = true;
      try {
        let { data } = await NcmContabilizar(this.idNcm).importprodutosShow({
          ...filters,
        });
        this.products = data.data;
        this.lastPage = data.last_page;
        this.currentPage = data.current_page;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },

    formatText(text) {
      return text.replace(/-Ped.*/, "");
    },

    closeModal() {
      this.$emit("update:dialog", false);
    },
  },
};
</script>
<style>
.magin-text {
  margin: 100px 0;
}
</style>
